import React from 'react';
import useAppContext from '../../contexts/UseAppContext';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import scanIcon from './images/scan.png';
import './QRScannerMessage.css';

function QRScannerMessage() {
    const context = useAppContext();

    const messageStyle = () => {
        return {
            height: context.qrScannerMessageHeight
        };
    };

    return (
        <div className='qr-scanner-message' style={messageStyle()}>
            <div className='qr-scanner-message_icon'>
                <ImageWrapper
                    image={scanIcon}
                    alt='Scan'
                    display='block'
                    width={46}
                    height='auto'
                    errorWidth={undefined}
                    errorHeight={undefined}
                    errorPadding={undefined}
                    margin={5}
                    borderRadius={0}
                    transition={true}
                    loadDelay={0.1}
                    onLoad={undefined}
                    onMouseEnter={undefined}
                    onMouseLeave={undefined}
                />
            </div>
            <div className='qr-scanner-message_content'>Apunta hacia el código QR para escanearlo</div>
        </div>
    );
}

export default QRScannerMessage;